<div id="headerSorting" class="row header-single">
    <h1>{{offerInfo.hotel.name}}</h1>
</div>
<div *ngIf="loading" class="loader"></div>
<div id="singleHotel" class="hotelSingleWrapper" style="width: 100%;" *ngIf="!loading">
  <div *ngIf="!isMobile()" id="" class="row" style="padding-top:0px;margin:0;">
    <section class="col-md-12" style="padding:0;">
      <div class="warning">
        <img class="warning__icon" src="../../../../assets/img/icons/icon_warning.svg" alt="Warning Icon">
        <h1 class="warning__message">This is only a preview of your property page.</h1>
      </div>
      <ngb-carousel [interval]="8000" *ngIf="offerInfo && offerInfo.propertyPics" (slide)="onSlidePropertyPics($event)">
        <ng-template ngbSlide ngbSlide *ngFor="let image of offerInfo.propertyPics; let i = index" [id]="i">
          <div *ngIf="image.preloaded" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                        'background-position': 'center center',
                        'background-repeat': 'no-repeat',
                        'background-size': 'cover',
                        'display': 'inline-block',
                        'height': '100%',
                        'width': '100%',
                        'background-color': 'rgba(0,0,0,.8)',
                        'position': 'relative',
                        'transition': 'transform 0.1s linear 0s',
                        'height': '550px'}">
          </div>
        </ng-template>
      </ngb-carousel>
    </section>
    <nav class="navbar navbar-expand-lg hotel-single-menu">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item active">
            <a class="nav-link">Room</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToAmentities()">Amenities & Services</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToDetails()">Details</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToLocation()">Points of Interest</a>
          </li>
          <div class="popup" [ngClass]="isClicked === true?'show':''">
            <span class="popuptext" [ngStyle]="isClicked === true?{'visibility':'visible'}:{'visibility':'hidden'}">You
              have to
              choose a room first</span>
          </div>
          <a class="bookBtn" (click)="bookNow()">Book Now</a>
        </ul>
      </div>
    </nav>
    <div *ngIf="!isMobile()" class="request">
      <div *ngIf="this.offerInfo" class="request__wrapper">
        <div class="request__details">
          <span class="request__text" *ngIf="this.resultsContainer.requestForSearch">Stay Dates</span>
          <span class="request__number">17/6/2021 - 25/6/2021</span>
        </div>
        <div class="request__details">
          <span class="request__text">Adults</span>
          <span class="request__number">4</span>
        </div>
        <div class="request__details">
          <span class="request__text">Children</span>
          <span class="request__number">0</span>
        </div>
        <div class="request__details">
          <span class="request__text">nights</span>
          <span class="request__number">9</span>
        </div>
        <div title="Select accommodation and experiences from below to adjust the price."
          class="request__details request__booking">
          <span class="request__text">total booking</span>
          <span class="request__number">2544€</span>
          <span class="request__text">(Includes all taxes)</span>
        </div>
        <div class="request__details">
          <span class="request__text">Location</span>
          <button class="request__button" (click)="openMapWindowDesktop()">Toggle Map</button>
        </div>
      </div>
      <div *ngIf="isMapDesktopOpen" id="map-canvas" class="request-info-map">
        <app-map-canvas *ngIf="markers" [markers]="markers" [mapCenter]="mapCenter" [hotels]="hotels"
          [hasInfoWindow]="false">
        </app-map-canvas>
      </div>
    </div>
    <div class="horizontal-seperator"></div>
    <main *ngIf="!isMobile()" class="singleTabs">
      <app-hotel-single-inner [roomOffers]="roomOffers" [hotelInfo]="offerInfo" [nights]=5
        [cards]="offerInfo.creditCards"></app-hotel-single-inner>

      <app-hotel-single-facilities id="amentities" [facilities]="facilitiesTab">
      </app-hotel-single-facilities>

      <app-hotel-single-description id="details" [hotelDscription]="hotelDscription">
      </app-hotel-single-description>

      <app-hotel-single-location id="location" [locations]="locations"></app-hotel-single-location>

    </main>
  </div>

  <div *ngIf="isMobile()" id="carouselMobile" class="container">
    <span (click)="goBack()" class="backArrow">&#8592;</span>
    <div class="request__details--mobile">
      <div class="dark-bg">
        <p class="checkinoutm">24-06-2021 - 27-06-2021</p>
        <p class="guestsm">8 Guests</p>
      </div>
    </div>
    <div class="row">
      <section class="col-md-12" style="padding:0;">
        <swiper [config]="config" style="width: 100%;">
          <div class="swiper-wrapper">
            <img class="swiper-slide" *ngFor="let image of offerInfo.propertyPics" [ngStyle]="{ 'background-image': 'url(' + image.pictureUrl + ')',
                            'background-position': 'center center',
                            'background-repeat': 'no-repeat',
                            'background-size': 'cover',
                            'display': 'inline-block',
                            'width': '100%',
                            'background-color': 'rgba(0,0,0,.8)',
                            'position': 'relative',
                            'transition': 'transform 0.1s linear 0s',
                            'height': '250px'}" />
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </swiper>
      </section>
      <div class="row col-lg-12 request-info-navbar" *ngIf="this.offerInfo">
        <div class="hotel-name">
          <h3>{{ offerInfo.hotel.name }}</h3>
        </div>
      </div>
      <div>
        <button class="map-btn-mobile" (click)="openMapWindow()"><img src="../../../assets/img/map.svg" alt="">show on
          map</button>
      </div>
      <div class="col-md-12 col-12 col-sm-12">
        <main class="singleTabs">
          <app-hotel-single-description [hotelDscription]="hotelDscription"></app-hotel-single-description>
          <app-hotel-single-facilities [facilities]="facilitiesTab"></app-hotel-single-facilities>
          <app-hotel-single-inner *ngIf="tabHeaderInfo" [hotelName]="hotelName" [roomOffers]="roomOffers"
            [nights]="tabHeaderInfo.numberOfNightsSafari" [cards]="offerInfo.creditCards" [hotelInfo]="offerInfo"
            (optionsChanged)="selectMeal($event)">
          </app-hotel-single-inner>
        </main>
        <div class="row" *ngIf="isMobile()" id="total-book">
          <div class="col-md-5 col-lg-5 col-sm-5 col-5 price header-price float-right" style="text-align:center;">
            <span class="txt">total booking</span> <br>
            <span class="value">2543€</span>
            <span class="txt mobileTaxInfo">(Includes all taxes)</span>
          </div>
          <div class="col-md-7 col-sm-7 col-lg-7 col-7">
            <a class="bookBtn">Book Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section *ngIf="isMobile()" id="right" class="col-md-12 col-lg-3 right-sidebar-results overlay">
    <div class="row" *ngIf="mobileFullsreenWindow.isMapOpen">
      <div class="col-md-12 col-lg-12">
        <div class="menu-header">
          <a href="javascript:void(0)" class="closebtnfilters" (click)="closeFilterWindow('map')">&times;
          </a>
          <span id="map-2" class="map-btn-mobile">Map</span>
        </div>
      </div>
    </div>
    <div class="sidebar-item overlay-content">
      <div class="make-me-sticky">
        <div id="map-canvas">
          <app-map-canvas *ngIf="markers" [markers]="markers" [mapCenter]="mapCenter" [hotels]="hotels"
            [hasInfoWindow]="false"></app-map-canvas>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Swiper JS -->
<script src="../../../../../node_modules/swiper/js/swiper.js"></script>

<!-- Initialize Swiper -->
<script>
  var swiper = new Swiper('.swiper-container', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
</script>